import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {AdminOptionsComponent} from './admin-options.component';
import {RouterModule} from '@angular/router';


@NgModule({
    imports: [
        PagesSharedModule,
        RouterModule
    ],
    declarations: [
        AdminOptionsComponent
    ],
    entryComponents: [
        AdminOptionsComponent
    ],
    exports: [
        AdminOptionsComponent
    ]
})
export class AdminOptionsModule {
}
